import { Tag } from "@/components/elements/Tag";
import { background, lightBlue, state, text } from "@/theme/colors";
import { RENEW_VISA_DOCUMENT_STATUS, RENEW_VISA_DOCUMENT_STATUS_LABEL } from "@/types/enum";
import { FC, useMemo } from "react";

export type TRenewVisaDocumentStatusTagProps = {
  status: string;
};

export const RenewVisaDocumentStatusTag: FC<TRenewVisaDocumentStatusTagProps> = ({ status }) => {
  const tagProps = useMemo(() => {
    switch (status) {
      case RENEW_VISA_DOCUMENT_STATUS.NOT_CREATED:
        return { color: text.tertiary };
      case RENEW_VISA_DOCUMENT_STATUS.IN_PROGRESS:
        return { color: state.warning_1 };
      case RENEW_VISA_DOCUMENT_STATUS.UNDER_REVIEW:
        return { color: state.link_1 };
      case RENEW_VISA_DOCUMENT_STATUS.APPROVED:
        return { color: lightBlue[60] };
      case RENEW_VISA_DOCUMENT_STATUS.COMPLETE:
        return { color: state.success_1 };
      case RENEW_VISA_DOCUMENT_STATUS.WITHDRAWN:
        return { color: background.pink };
      case RENEW_VISA_DOCUMENT_STATUS.REJECTED:
        return { color: background.pink };
      default:
        return { color: state.success_1 };
    }
  }, [status]);

  return <Tag title={RENEW_VISA_DOCUMENT_STATUS_LABEL[status]} variant="bold" textColor="white" {...tagProps} />;
};
